import { z } from 'zod';

export const postPlatformSchema = z.object({
  id: z.string(),
  enabled: z.boolean(),
  content: z.string().nullable().optional(),
  externalData: z.record(z.string(), z.unknown()).nullable().optional(),
  format: z.string().nullable().optional(),
  latestReview: z.any().nullable().optional(),
  reviewStatus: z.enum(['approve', 'changes_requested', 'pending']).nullable().optional(),
  postId: z.string(),
  clientPlatformAccountId: z.string(),
  sourcePostPlatformId: z.string().nullable().optional(),
  attachmentIds: z.array(z.string()).nullable().optional(),
  validation: z.unknown().nullable().optional(),
  deletedOnPlatform: z.boolean().default(false).optional(),
  suggestedContent: z.string().nullable().optional(),
  suggestedContentUserId: z.string().nullable().optional(),
  suggestedContentCreatedAt: z.coerce.date().nullable().optional(),
  suggestedContentUpdatedAt: z.coerce.date().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type PostPlatformSchema = z.infer<typeof postPlatformSchema>;
